import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";

const useStyles = createUseStyles(theme => ({
  container: {
    width: "100%",
    height: "100%",
    display: "none",
    position: "absolute",
    zIndex: 1000,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  active: {
    display: "block",
  },
  message: {
    position: "absolute",
    width: "100%",
    top: "calc(50% + 65px)",
    textAlign: "center",
    color: "#fff",
  },
  four: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    borderTop: `${theme.colorSecondary} 3px solid`,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(0)",
    position: "absolute",
    animationName: "$rotateRight",
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    transitionProperty: "transform",
  },
  three: {
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    borderRight: "#fff 3px solid",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(0)",
    position: "absolute",
    animationName: "$rotateLeft",
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    transitionProperty: "transform",
  },
  two: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    borderBottom: `${theme.colorAlternative} 3px solid`,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(0)",
    position: "absolute",
    animationName: "$rotateRight",
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    transitionProperty: "transform",
  },
  one: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    borderLeft: `${theme.colorPrimary} 3px solid`,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(0)",
    position: "absolute",
    animationName: "$rotateLeft",
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    transitionProperty: "transform",
  },
  "@keyframes rotateLeft": {
    from: { transform: "translate(-50%, -50%) rotate(0deg)" },
    to: { transform: "translate(-50%, -50%) rotate(-360deg)" },
  },
  "@keyframes rotateRight": {
    from: { transform: "translate(-50%, -50%) rotate(0deg)" },
    to: { transform: "translate(-50%, -50%) rotate(360deg)" },
  },
}));

const LoadingModal = ({ show, message }) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.container, {
        [classes.active]: show,
      })}
    >
      <div className={classes.one} />
      <div className={classes.two} />
      <div className={classes.three} />
      <div className={classes.four} />
      {message !== undefined && (
        <div className={classes.message}>Saving...</div>
      )}
    </div>
  );
};

export default LoadingModal;
